export function isExtendedPriceRangeSchemaExperimentEnabled(
	displayId: string,
): boolean {
	const lastDigit = Number.parseInt(displayId.charAt(displayId.length - 1));
	return lastDigit === 0 || (lastDigit >= 6 && lastDigit <= 9);
}

export function getPriceRangeText(
	startingCost: string | null | undefined,
): string {
	return `Prices starting at ${startingCost} depending on services and availability`;
}
